import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

interface UserItem {
    id: string;
    name: string;
    email: string;
    userGroup: string;
    status: string;
    lastLogin: string;
    createdAt: string;
}

const Users = () => {
    const columns = [
        {
            name: 'Name',
            selector: (row: UserItem) => row.name,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: UserItem) => row.email,
            sortable: true,
        },
        {
            name: 'User Group',
            selector: (row: UserItem) => row.userGroup,
            cell: (row: UserItem) => (
                <span className={`badge bg-${
                    row.userGroup === 'ADMIN' ? 'danger' : 
                    row.userGroup === 'MANAGER' ? 'warning' : 'info'
                }`}>
                    {row.userGroup}
                </span>
            ),
        },
        {
            name: 'Status',
            selector: (row: UserItem) => row.status,
            cell: (row: UserItem) => (
                <span className={`badge bg-${row.status === 'Active' ? 'success' : 'secondary'}`}>
                    {row.status}
                </span>
            ),
        },
        {
            name: 'Last Login',
            selector: (row: UserItem) => row.lastLogin,
            sortable: true,
        },
        {
            name: 'Created At',
            selector: (row: UserItem) => row.createdAt,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row: UserItem) => (
                <div className="btn-group">
                    <button className="btn btn-sm btn-primary">
                        <i className="fa fa-edit me-2"></i>Edit
                    </button>
                    <button className="btn btn-sm btn-outline-danger">
                        <i className="fa fa-trash me-2"></i>Delete
                    </button>
                </div>
            ),
        },
    ];

    const data = [
        {
            id: '1',
            name: 'John Doe',
            email: 'john@example.com',
            userGroup: 'ADMIN',
            status: 'Active',
            lastLogin: '2024-02-21 10:30',
            createdAt: '2024-01-01',
        },
        // Add more sample data as needed
    ];

    return (
        <div>
            <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
                <div className="container-fluid">
                    <div className="row g-3 mb-3 align-items-center">
                        <div className="col">
                            <ol className="breadcrumb bg-transparent mb-0">
                                <li className="breadcrumb-item"><Link className="text-secondary" to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Users</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-body px-xl-4 px-sm-2 px-0 py-lg-2 py-1 mt-0 mt-lg-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h6 className="card-title mb-0">System Users</h6>
                                    <div className="dropdown morphing scale-left">
                                        <button className="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#addUserModal">
                                            <i className="fa fa-plus me-2"></i>Add User
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            pagination
                                            highlightOnHover
                                            striped
                                            responsive
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add User Modal */}
            <div className="modal fade" id="addUserModal" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add New User</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input type="text" className="form-control" placeholder="Enter full name" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input type="email" className="form-control" placeholder="Enter email" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">User Group</label>
                                    <select className="form-select">
                                        <option value="">Select user group</option>
                                        <option value="ADMIN">Admin</option>
                                        <option value="MANAGER">Manager</option>
                                        <option value="USER">User</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Password</label>
                                    <input type="password" className="form-control" placeholder="Enter password" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Confirm Password</label>
                                    <input type="password" className="form-control" placeholder="Confirm password" />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary">Add User</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Users; 